import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class WeightGridKey extends BasicEntity {
code: string;
order: number | null;
weightGridCode: string;
}

